import { useState } from 'react'
import { normalizeMessages } from '@/features/chat/messageNormalize'

/** @param {ReturnType<typeof import('@/features/chat/chatPersist').loadChatPersist>} persisted */
export function useChatThreadSlices(persisted) {
  const [threads, setThreads] = useState(persisted?.threads ?? [])
  const [dismissedNoteThreadIds, setDismissedNoteThreadIds] = useState(
    persisted?.dismissedNoteThreadIds ?? [],
  )
  const [pinnedThreadIds, setPinnedThreadIds] = useState(persisted?.pinnedThreadIds ?? [])
  const [messagesByThreadId, setMessagesByThreadId] = useState(() => {
    const raw = persisted?.messagesByThreadId ?? {}
    /** @type {Record<string, any[]>} */
    const out = {}
    for (const [tid, list] of Object.entries(raw)) out[tid] = normalizeMessages(list)
    return out
  })
  const [threadShareThread, setThreadShareThread] = useState(/** @type {{ id: string, title?: string, members?: unknown[] } | null} */ (null))

  return {
    threads,
    setThreads,
    dismissedNoteThreadIds,
    setDismissedNoteThreadIds,
    pinnedThreadIds,
    setPinnedThreadIds,
    messagesByThreadId,
    setMessagesByThreadId,
    threadShareThread,
    setThreadShareThread,
  }
}
